import React from 'react';
import { Component } from 'react';
import classNames from 'classnames';

import styles from '../styles/Start.css';
import uiStyles from  '../styles/common.css';

const racers = [
  { name: "red", className: styles.racerRed },
  { name: "blue", className: styles.racerBlue },
  { name: "green", className: styles.racerGreen },
  { name: "teal", className: styles.racerTeal }
]

export default class StartScreen extends Component {

  constructor () {
    super();

    this.state = {
      racer: "teal"
    };
  }

  setRacer (racer) {
    this.setState({racer});
  }

  render () {
    const selectedRacer = this.state.racer;
    const controlsStyle = {

    }

    return (
      <div id="start" className={styles.startScreen}>
        <div className={styles.controls} style={controlsStyle}>
          <h1 className={styles.title}>Choose your racer!</h1>
          {
            racers.map(racer => (
              <RacerBtn
                key={racer.name}
                racerClass={racer.className}
                selected={racer.name == selectedRacer}
                onClick={()=>this.setRacer(racer.name)} />
            ))
          }
          <a className={styles.startBtn} onClick={()=>this.props.onStartBtn(this.state.racer)}>Start</a>
          <a className={styles.instructionsBtn} onClick={()=>this.props.onInstructionsBtn()}>Instructions</a>
        </div>
      </div>
    );
  }
}

const RacerBtn = (props) => {
  const className = classNames(
    props.racerClass,
    {
      [styles.selectedRacer]: props.selected
    });
  return <button className={className} onClick={()=>props.onClick()} />;
}


// WEBPACK FOOTER //
// ./src/components/Start.js